import {
  put, takeLatest, takeEvery, select, all,
} from 'redux-saga/effects';
import _ from 'lodash';
import history from 'app/routes/history';
import {
  TeammoApi,
  normalize,
  compilePaginationObject,
} from 'app/utils/redux/helpers';
import {
  connectionSchema,
  connectionListSchema,
} from 'app/utils/redux/schemas';
import { handleError } from 'app/utils/handlers/handleError';
import { loadingStart, loadingFinish } from 'app/ducks/loading/actions';
import { sagaActions } from 'app/ducks/connections/actions';
import { ConnectionsActionTypes as types } from 'app/ducks/connections/types';

function* createConnectionSaga(action): any {
  yield put(sagaActions.createConnectionPending(action.payload));
  const [error, response] = yield (yield TeammoApi(
    yield select(),
  )).connections.create(action.payload);

  if (response) {
    const normalizedResponse = normalize(response, connectionSchema);
    history.push('/connections');
    yield put(sagaActions.createConnectionSuccess(normalizedResponse));
  } else {
    yield put(
      handleError(
        error,
        sagaActions.createConnectionFailed(
          _.isEmpty(error) ? {} : error.response.data.errors,
        ),
      ),
    );
  }
}

function* updateConnectionSaga(action): any {
  yield put(sagaActions.updateConnectionPending(action.payload));
  const [error, response] = yield (yield TeammoApi(
    yield select(),
  )).connections.update(action.payload);

  if (response) {
    const normalizedResponse = normalize(response, connectionSchema);

    yield put(sagaActions.updateConnectionSuccess(normalizedResponse));
  } else {
    yield put(
      handleError(
        error,
        sagaActions.updateConnectionFailed(
          _.isEmpty(error) ? {} : error.response.data.errors,
        ),
      ),
    );
  }
}

function* getConnectionSaga(action): any {
  yield put(sagaActions.getConnectionPending());

  const [error, response] = yield (yield TeammoApi(
    yield select(),
  )).connections.show(action.payload);
  if (response) {
    const normalizedResponse = normalize(response, connectionSchema);
    yield put(sagaActions.getConnectionSuccess(normalizedResponse));
    return normalizedResponse.entities.connections[
      normalizedResponse.result
    ];
  }
  yield put(
    handleError(
      error,
      sagaActions.getConnectionFailed(
        _.isEmpty(error) ? {} : error.response.data.errors,
      ),
    ),
  );
  return null;
}

function* getAllConnectionsSaga(action): any {
  yield put(
    sagaActions.getAllConnectionsPending(
      action.payload.compile ? action.payload.pagination : {},
    ),
  );
  yield put(loadingStart());
  const paginationObject = action.payload.compile
    ? compilePaginationObject(
      yield select((state) => state.connections.pagination),
    )
    : action.payload.pagination;
  const [error, response] = yield (yield TeammoApi(
    yield select(),
  )).connections.list(
    paginationObject,
  );

  if (response) {
    const normalizedResponse = normalize(
      response,
      connectionListSchema,
    );

    yield put(
      sagaActions.getAllConnectionsSuccess(
        normalizedResponse,
        response.meta,
      ),
    );
    yield put(loadingFinish());
  } else {
    yield put(
      error,
      sagaActions.getAllConnectionsFailed(
        _.isEmpty(error) ? {} : error.response.data.errors,
      ),
    );
  }
}

function* deleteConnectionSaga(action): any {
  yield put(sagaActions.deleteConnectionPending(action.payload.id));
  const [error, response] = yield (yield TeammoApi(yield select())).connections.delete(
    action.payload,
  );

  if (response || _.isEmpty(error)) {
    // const normalizedResponse = normalize(response, teamMemberSchema);
    yield put(sagaActions.deleteConnectionSuccess(action.payload.id));
  } else {
    yield put(
      handleError(
        error,
        sagaActions.deleteConnectionFailed(
          _.isEmpty(error) ? {} : error.response.data.errors,
        ),
      ),
    );
  }
}

/* ********************************* SAGA WATCHERS ********************************* */

function* createConnectionSagaWatcher(): any {
  yield takeLatest(
    types.CREATE_CONNECTION_REQUESTED,
    createConnectionSaga,
  );
}

function* updateConnectionSagaWatcher(): any {
  yield takeLatest(
    types.UPDATE_CONNECTION_REQUESTED,
    updateConnectionSaga,
  );
}

function* getConnectionSagaWatcher(): any {
  yield takeLatest(
    types.GET_CONNECTION_REQUESTED,
    getConnectionSaga,
  );
}

function* getAllConnectionsSagaWatcher(): any {
  yield takeLatest(
    types.GET_ALL_CONNECTIONS_REQUESTED,
    getAllConnectionsSaga,
  );
}
function* deleteConnectionSagaWatcher(): any {
  yield takeLatest(types.DELETE_CONNECTION_REQUESTED, deleteConnectionSaga);
}

export default function* root(): any {
  yield all([
    createConnectionSagaWatcher(),
    updateConnectionSagaWatcher(),
    getConnectionSagaWatcher(),
    getAllConnectionsSagaWatcher(),
    deleteConnectionSagaWatcher(),
  ]);
}
